import React from "react";
import useSessionService from "../../services/useSessionService";
import { StyledRouterLink } from "../../styling/card";
import {
  Container,
  Tile,
  SessionTile,
  DateTime,
  RightTile,
  Spaces,
  SubText,
  Session,
  TextWrapper,
} from "./SessionsCard.styles";

interface SessionCardProps {
  bakeID: number;
}

export const SessionsCard: React.FC<SessionCardProps> = ({ bakeID }) => {
  const { bakeSessions } = useSessionService(bakeID);

  return (
    <Container>
      {bakeSessions?.map((session) => {
        const onWaitingList = session.spaces === 0;
        return (
          <Tile key={session.id}>
            <StyledRouterLink
              to={{
                pathname: "/register",
                state: { sessionID: session.id, onWaitingList },
              }}
            >
              <Session waitingList={onWaitingList}>
                <SessionTile>
                  <TextWrapper>
                    <DateTime>{session.time} Bake</DateTime>
                    <SubText>
                      {session.spaces > 0
                        ? "Register for this session"
                        : "Session full. Join the waiting list"}
                    </SubText>
                  </TextWrapper>
                  {session.spaces > 0 ? (
                    <RightTile>
                      <Spaces>{session.spaces}</Spaces>
                      {session.spaces > 1 ? "Spaces" : "Space"} Left
                    </RightTile>
                  ) : (
                    <RightTile>
                      <Spaces>{session.waitingList}</Spaces>On Waiting
                      <br />
                      List
                    </RightTile>
                  )}
                </SessionTile>
              </Session>
            </StyledRouterLink>
          </Tile>
        );
      })}
    </Container>
  );
};
